import { render, staticRenderFns } from "./menu-version-translation-form.vue?vue&type=template&id=1bb07ae7"
import script from "./menu-version-translation-form.vue?vue&type=script&lang=js"
export * from "./menu-version-translation-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports